import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import styles from './index.module.scss.js';

const SocialsList = ({
  data,
  className,
  style
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, "socials-list", className), style }, data.map((item, i) => /* @__PURE__ */ React.createElement(
  Link,
  {
    to: item.href,
    key: i,
    className: cx(styles.box__item, "socials-list__item"),
    target: "_blank",
    rel: "noreferrer"
  },
  item.icon
)));
SocialsList.displayName = "SocialsList";

export { SocialsList };
//# sourceMappingURL=index.js.map
